var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/receipt-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.4996 7.29902V9.90052C25.4996 11.599 24.4245 12.674 22.726 12.674H19.0496V5.15977C19.0496 3.96652 20.0278 2.99902 21.2211 2.99902C22.3928 3.00977 23.4678 3.48277 24.2418 4.25677C25.0158 5.04152 25.4996 6.11652 25.4996 7.29902Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 8.37402V23.424C4 24.3163 5.01047 24.8215 5.71997 24.284L7.55825 22.908C7.98825 22.5855 8.59026 22.6285 8.97726 23.0155L10.7617 24.8108C11.181 25.23 11.869 25.23 12.2883 24.8108L14.0943 23.0048C14.4705 22.6285 15.0725 22.5855 15.4918 22.908L17.33 24.284C18.0395 24.8108 19.05 24.3055 19.05 23.424V5.14902C19.05 3.96652 20.0175 2.99902 21.2 2.99902H9.375H8.3C5.075 2.99902 4 4.92327 4 7.29902V8.37402Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.2998 10.5254H14.7498",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.10669 14.8232H13.9442",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/dollar-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.25 28.25C23.5637 28.25 26.25 25.5637 26.25 22.25C26.25 18.9363 23.5637 16.25 20.25 16.25C16.9363 16.25 14.25 18.9363 14.25 22.25C14.25 25.5637 16.9363 28.25 20.25 28.25Z",
    fill: "white",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    d: "M21.5593 21.5996C21.4976 21.3086 21.3712 21.0353 21.1894 20.7998H22.3995C22.5056 20.7998 22.6073 20.7577 22.6823 20.6827C22.7573 20.6077 22.7994 20.506 22.7994 20.3999C22.7994 20.2938 22.7573 20.1921 22.6823 20.1171C22.6073 20.0421 22.5056 20 22.3995 20H18.4005C18.2944 20 18.1927 20.0421 18.1177 20.1171C18.0427 20.1921 18.0006 20.2938 18.0006 20.3999C18.0006 20.506 18.0427 20.6077 18.1177 20.6827C18.1927 20.7577 18.2944 20.7998 18.4005 20.7998H19.6002C19.8474 20.8008 20.0883 20.8782 20.2899 21.0214C20.4915 21.1645 20.6439 21.3665 20.7263 21.5996H18.4005C18.2944 21.5996 18.1927 21.6417 18.1177 21.7167C18.0427 21.7917 18.0006 21.8934 18.0006 21.9995C18.0006 22.1056 18.0427 22.2073 18.1177 22.2823C18.1927 22.3573 18.2944 22.3994 18.4005 22.3994H20.7263C20.6439 22.6325 20.4915 22.8345 20.2899 22.9776C20.0883 23.1208 19.8474 23.1982 19.6002 23.1992H18.4005C18.3133 23.1991 18.2285 23.2274 18.159 23.2799C18.0894 23.3324 18.0389 23.4062 18.0152 23.49C17.9914 23.5739 17.9957 23.6632 18.0273 23.7444C18.059 23.8256 18.1163 23.8942 18.1905 23.9398L21.3897 25.9393C21.4799 25.9955 21.5887 26.0136 21.6922 25.9896C21.7957 25.9656 21.8854 25.9015 21.9416 25.8114C21.9978 25.7212 22.0159 25.6124 21.9919 25.5089C21.9679 25.4054 21.9038 25.3157 21.8136 25.2595L19.7837 23.9906C20.2112 23.9508 20.6146 23.7747 20.9344 23.4882C21.2542 23.2017 21.4734 22.82 21.5597 22.3994H22.3995C22.5056 22.3994 22.6073 22.3573 22.6823 22.2823C22.7573 22.2073 22.7994 22.1056 22.7994 21.9995C22.7994 21.8934 22.7573 21.7917 22.6823 21.7167C22.6073 21.6417 22.5056 21.5996 22.3995 21.5996H21.5593Z",
    fill: "#393945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillicon);
export default __webpack_public_path__ + "static/media/billicon.9617fe1d.svg";
export { ForwardRef as ReactComponent };